import { GenericMarkerData } from "@primayer/prime-google-map";
export default class MarkerData extends GenericMarkerData {
  constructor(dataObj) {
    if (dataObj) {
      super(dataObj);
      this.id = dataObj.id;
      this.name = dataObj.name;
      this.latitude = null;
      this.longitude = null;

      //google map attributes
      this._animation = dataObj.animation;
      this._attribution = dataObj.attribution;
      this._clickable = dataObj.clickable;
      this._cursor = dataObj.cursor;
      this._draggable = dataObj.draggable;
      this._icon = dataObj.icon;
      this._label = dataObj.label;
      this._opacity = dataObj.opacity;
      this._options = dataObj.options;
      this._place = dataObj.place;
      this._shape = dataObj.shape;
      this._title = dataObj.title;
      this._zIndex = dataObj.zIndex;

      // lat/long catchers
      if (dataObj.lat) {
        this.latitude = dataObj.lat;
      }
      if (dataObj.latitude) {
        this.latitude = dataObj.latitude;
      }
      if (dataObj.long) {
        this.longitude = dataObj.longitude;
      }
      if (dataObj.lng) {
        this.longitude = dataObj.longitude;
      }
      if (dataObj.longitude) {
        this.longitude = dataObj.longitude;
      }
    } else {
      super();
      this.id = -1;
      this.name = null;
      this.latitude = null;
      this.longitude = null;

      //google map attributes
      this._animation = 1;
      this._attribution = null;
      this._clickable = false;
      this._cursor = "default";
      this._draggable = false;
      this._icon = null;
      this._label = null;
      this._opacity = 1;
      this._options = null;
      this._place = null;
      this._shape = null;
      this._title = null;
      this._zIndex = 2;
    }
  }

  get googleLocation() {
    return { lat: this.latitude, lng: this.longitude };
  }

  get animation() {
    return this._animation;
  }
  set animation(value) {
    this._animation = value;
  }
  get attribution() {
    return this._attribution;
  }
  set attribution(value) {
    this._attribution = value;
  }
  get clickable() {
    return this._clickable;
  }
  set clickable(value) {
    this._clickable = value;
  }
  get cursor() {
    return this._cursor;
  }
  set cursor(value) {
    this._cursor = value;
  }
  get draggable() {
    return this._draggable;
  }
  set draggable(value) {
    this._draggable = value;
  }
  get icon() {
    return this._icon;
  }
  set icon(value) {
    this._icon = value;
  }
  get label() {
    return this._label;
  }
  set label(value) {
    this._label = value;
  }
  get opacity() {
    return this._opacity;
  }
  set opacity(value) {
    this._opacity = value;
  }
  get options() {
    return this._options;
  }
  set options(value) {
    this._options = value;
  }
  get place() {
    return this._place;
  }
  set place(value) {
    this._place = value;
  }
  get shape() {
    return this._shape;
  }
  set shape(value) {
    this._shape = value;
  }
  get title() {
    return this._title;
  }
  set title(value) {
    this._title = value;
  }
  get zIndex() {
    return this._zIndex;
  }
  set zIndex(value) {
    this._zIndex = value;
  }
}
